import { Builder } from '@builder.io/react';
import React, { useEffect, useRef, useState } from 'react';
import { selectProducts } from '../../../../../../store/products';
import { useSelector } from 'react-redux';
// import QurbanWidgetContent from '../../../../../general/qurbanWidget/qurbanWidgetContent';
import QurbanTabContent from '../../../../../general/qurbanWidget/tab-content';
import CustomButton from '../../../../../general/button';
import { useNavigate } from 'react-router-dom';

const QurbanWidget = props => {
  const { tabs } = props;
  // console.log("propsss===",props)
  const contentRef = useRef(null);
  const visibleTabs = tabs.filter(tab => tab.isTabsVisible !== false);
  const [activeTabProducts, setActiveTabProducts] = useState(0);
  const [tabTopProducts, setTabTopProducts] = useState([]);
  const [tabBottomeProducts, setTabBottomeProducts] = useState([]);
  const [extraTabProducts, setExtraTabProducts] = useState([]);
  const [topCardProduct, setTopCardProduct] = useState([]);
  const [secondCardProduct, setSecondCardProduct] = useState([]);
  const [limitedProduct, setLimitedProduct] = useState([]);
  const _allProducts = useSelector(state => selectProducts(state));
  const navigate = useNavigate();

  const getAllProducts = _allProducts => {
    let tempSelectedTopProducts = [];
    let tempSelectedBottomProducts = [];
    let tempSelectedTopCardProduct = [];
    let tempSelectedSecondCardProduct = [];
    let tempSelectedLimitedProduct = [];
    let tempExtraProducts = [];

    tabs.forEach(() => {
      tempSelectedTopCardProduct.push({ products: [] });
      tempSelectedTopProducts.push({ products: [] });
      tempSelectedBottomProducts.push({ products: [] });
      tempSelectedSecondCardProduct.push({ products: [] });
      tempSelectedLimitedProduct.push({ products: [] });
      tempExtraProducts.push({ products: [] });
    });

    const normalizeArray = value => {
      if (Array.isArray(value)) return value;
      if (typeof value === 'string') return value.split(',').map(id => id.trim());
      return [];
    };

    _allProducts.forEach(item => {
      item.sub_categories.forEach(innerItem => {
        innerItem.products.forEach(innerProduct => {
          tabs.forEach((tabItem, tabIndex) => {
            const topProductsArray = normalizeArray(tabItem.topProducts);
            const bottomProductsArray = normalizeArray(tabItem.bottomProducts);
            const extraProductsArray = normalizeArray(tabItem.extraProducts);

            if (topProductsArray.includes(innerProduct.creator)) {
              tempSelectedTopProducts[tabIndex].products.push(innerProduct);
            }
            if (bottomProductsArray.includes(innerProduct.creator)) {
              tempSelectedBottomProducts[tabIndex].products.push(innerProduct);
            }
            if (extraProductsArray.includes(innerProduct.creator)) {
              tempExtraProducts[tabIndex].products.push(innerProduct);
            }
            if (tabItem.topCardProduct && tabItem.topCardProduct.trim() === innerProduct.creator.trim()) {
              tempSelectedTopCardProduct[tabIndex].products.push(innerProduct);
            }
            if (tabItem.secondCardProduct && tabItem.secondCardProduct.trim() === innerProduct.creator.trim()) {
              tempSelectedSecondCardProduct[tabIndex].products.push(innerProduct);
            }
            if (tabItem.limitedProduct && tabItem.limitedProduct.trim() === innerProduct.creator.trim()) {
              tempSelectedLimitedProduct[tabIndex].products.push(innerProduct);
            }
          });
          // const topProductsArray = normalizeArray(topProducts);
          // const bottomProductsArray = normalizeArray(bottomProducts);

          // if (topProductsArray.includes(innerProduct.creator)) {
          //   tempSelectedTopProducts.products.push(innerProduct);
          // }
          // if (bottomProductsArray.includes(innerProduct.creator)) {
          //   tempSelectedBottomProducts.products.push(innerProduct);
          // }
          // if (topCardProduct && topCardProduct.trim() === innerProduct.creator.trim()) {
          //   tempSelectedTopCardProduct.products.push(innerProduct);
          // }
        });
      });
    });

    tabs.forEach((tabItem, tabIndex) => {
      if (tabItem.topProducts) {
        tempSelectedTopProducts[tabIndex].products = Array.from(new Set(tempSelectedTopProducts[tabIndex].products.map(item => item.creator)))
          .map(creator => {
            const foundProduct = tempSelectedTopProducts[tabIndex].products.find(product => product.creator === creator);
            return foundProduct;
          })
          .sort((a, b) => {
            return tabItem.topProducts.indexOf(a.creator) - tabItem.topProducts.indexOf(b.creator);
          });
      }
      if (tabItem.bottomProducts) {
        tempSelectedBottomProducts[tabIndex].products = Array.from(new Set(tempSelectedBottomProducts[tabIndex].products.map(item => item.creator)))
          .map(creator => {
            const foundProduct = tempSelectedBottomProducts[tabIndex].products.find(product => product.creator === creator);
            return foundProduct;
          })
          .sort((a, b) => {
            return tabItem.bottomProducts.indexOf(a.creator) - tabItem.bottomProducts.indexOf(b.creator);
          });
      }
      if (tabItem.extraProducts) {
        tempExtraProducts[tabIndex].products = Array.from(new Set(tempExtraProducts[tabIndex].products.map(item => item.creator)))
          .map(creator => {
            const foundProduct = tempExtraProducts[tabIndex].products.find(product => product.creator === creator);
            return foundProduct;
          })
          .sort((a, b) => {
            return tabItem.extraProducts.indexOf(a.creator) - tabItem.extraProducts.indexOf(b.creator);
          });
      }
    });

    setTabTopProducts(tempSelectedTopProducts);
    setTabBottomeProducts(tempSelectedBottomProducts);
    setExtraTabProducts(tempExtraProducts);
    setTopCardProduct(tempSelectedTopCardProduct);
    setSecondCardProduct(tempSelectedSecondCardProduct);
    setLimitedProduct(tempSelectedLimitedProduct);
  };

  useEffect(() => {
    if (tabs.length > 0) {
      _allProducts && Object.keys(_allProducts).length && getAllProducts(_allProducts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_allProducts, tabs]);

  return (
    <section className="bg-transparent">
      <style>
        {`
          @keyframes blink {
            0% { background-color: white; color: rgb(30,60,131); }
            50% { background-color: rgb(30,60,131); color: white; }
            100% { background-color: white; color: rgb(30,60,131); }
          }
          .blinking-tab {
            animation: blink 1s infinite;
          }
        `}
      </style>
      <div className="md:container w-full mx-auto px-0">
        <div className="w-full shadow-lg py-2">
          <div className={`flex flex-wrap gap-2 min-[501px]:gap-3 items-center justify-center ${visibleTabs.length > 0 ? '' : 'hidden'}`}>
            {/* {console.log("tabs=", tabs)} */}
            {tabs &&
              tabs.length > 1 &&
              tabs.map(({ title }, index) => (
                <button
                  key={`btn_${index}`}
                  onClick={() => {
                    setActiveTabProducts(index);
                  }}
                  className={`${
                    index === activeTabProducts ? 'bg-[#F60362] text-white' : 'bg-[#F8F8F8] text-[#78716C]'
                  } text-[14px] md:text-base- rounded-full max-[500px]:col-span-2- p-2 min-[501px]:px-4 min-[501px]:min-w-36 uppercase font-['Montserrat'] font-bold`}
                >
                  {title}
                </button>
              ))}
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 mt-3 md:mt-6">
            <div className="flex flex-col w-full justify-center">
              {tabs &&
                tabs.map(
                  (item, index) =>
                    index === activeTabProducts && (
                      <React.Fragment key={`description_${index}`}>
                        {/* <div className="flex w-full justify-center mb-6">
                      <p className="text-center text-white text-[18px] md:text-3xl md:w-2/3">{item.description}</p>
                    </div> */}
                        <div ref={contentRef}>
                          {/* {console.log("before content=", tabs,tabTopProducts)} */}
                          <QurbanTabContent
                            topProducts={tabTopProducts[index] ? tabTopProducts[index].products : []}
                            bottomProducts={tabBottomeProducts[index] ? tabBottomeProducts[index].products : []}
                            cardTitle={tabs[index] ? tabs[index].cardTitle : ''}
                            topCardTitle={tabs[index] ? tabs[index].topCardTitle : ''}
                            topCardProduct={topCardProduct[index] ? topCardProduct[index].products : []}
                            topCardProductTitle={tabs[index] ? tabs[index].topCardProductTitle : ''}
                            topCardImageBlue={tabs[index] ? tabs[index].topCardImageBlue : ''}
                            topCardImageBlue2={tabs[index] ? tabs[index].secondCardImageBlue : ''}
                            topCardProduct2={topCardProduct[index] ? secondCardProduct[index].products : []}
                            topCardProduct2Title={tabs[index] ? tabs[index].secondCardProductTitle : ''}
                            topCardTitle2={tabs[index] ? tabs[index].secondCardTitle : ''}
                            limitedTitle={tabs[index] ? tabs[index].limitedTitle : ''}
                            limitedProduct={limitedProduct[index] ? limitedProduct[index].products : []}
                            limitedImage={tabs[index] ? tabs[index].limitedImage : ''}
                            limitedText={tabs[index] ? tabs[index].limitedText : ''}
                            extraProducts={extraTabProducts[index] ? extraTabProducts[index].products : []}
                            showZakatButton={tabs[index] ? tabs[index].showZakatButton : false}
                            showProductsOneRow={tabs[index] ? tabs[index].showProductsOneRow : false}
                          />
                        </div>
                      </React.Fragment>
                    ),
                )}
            </div>
          </div>
        </div>
        {tabs &&
          tabs.map((item, index) => {
            // console.log("tabss=", tabs, activeTabProducts, tabs[index])
            if (index === activeTabProducts && tabs[index] && tabs[index].showZakatButton) {
              return (
                <div className="w-full py-2 mt-1 md:mt-4 md:pt-4">
                  <CustomButton
                    title={'Click here to give Zakat to Gaza'}
                    onClick={() => navigate('/zakat')}
                    className="!bg-LightBlue w-full text-white rounded-lg hover:bg-primaryDark text-xs h-[20px]"
                  />
                </div>
              );
            } else {
              return '';
            }
          })}
        {/* <div className={`flex flex-wrap items-center justify-center`}>
          <div className="flex flex-col w-full justify-center">
            <QurbanWidgetContent
              topList={widgetTopProducts ? widgetTopProducts.products : []}
              bottomList={widgetBottomeProducts ? widgetBottomeProducts.products : []}
              cardTitle={cardTitle}
              cardSubTitle={cardSubTitle}
              topCardTitle={topCardTitle}
              topCardProduct={widgetTopCardProduct ? widgetTopCardProduct : []}
              topCardImageBlue={topCardImageBlue}
            />
          </div>
        </div> */}
      </div>
    </section>
  );
};

Builder.registerComponent(QurbanWidget, {
  name: 'QurbanWidget',
  inputs: [
    {
      name: 'tabs',
      type: 'list',
      defaultValue: [],
      minRows: 0,
      maxRows: 6,
      defaultItem: {
        topBanner: '',
        title: '',
        description: '',
        cardTitle: '',
        cardSubTitle: '',
        topCardTitle: '',
        topCardProduct: '',
        topProducts: [],
        bottomProducts: [],
        extraProducts: [],
        isTabsVisible: true,
      },
      subFields: [
        {
          name: 'title',
          type: 'string',
          required: false,
          defaultValue: 'Tab',
          helpText: 'Enter the Tab Title.',
        },
        {
          name: 'description',
          type: 'string',
          required: false,
          helpText: 'Enter the Description.',
        },
        {
          name: 'cardTitle',
          type: 'string',
          required: false,
          helpText: 'Enter the Card Title.',
        },
        {
          name: 'cardSubTitle',
          type: 'html',
          required: false,
          helpText: 'Enter the Card Sub Title.',
        },
        {
          name: 'topCardTitle',
          type: 'string',
          required: false,
          helpText: 'Enter the top Card Title.',
        },
        {
          name: 'topCardImageBlue',
          type: 'file',
          required: true,
          allowedFileTypes: ['png', 'jpg', 'jpeg'],
          description: 'Image for the Food for Orphan main',
        },
        {
          name: 'topCardProduct',
          type: 'string',
          required: false,
          helpText: 'Enter the top Card Product.',
        },
        {
          name: 'topCardProductTitle',
          type: 'string',
          required: false,
          helpText: 'Enter the top Card Product Title.',
        },
        {
          name: 'secondCardTitle',
          type: 'string',
          required: false,
          helpText: 'Enter the top Card Title.',
        },
        {
          name: 'secondCardImageBlue',
          type: 'file',
          required: true,
          allowedFileTypes: ['png', 'jpg', 'jpeg'],
          description: 'Image for the Food for Orphan main',
        },
        {
          name: 'secondCardProduct',
          type: 'string',
          required: false,
          helpText: 'Enter the top Card Product.',
        },
        {
          name: 'secondCardProductTitle',
          type: 'string',
          required: false,
          helpText: 'Enter the top Card Product Title.',
        },
        {
          name: 'limitedTitle',
          type: 'string',
          defaultValue: 'Limited Stock Available!',
          required: false,
          helpText: 'Enter the Limited Section Title.',
        },
        {
          name: 'limitedText',
          type: 'string',
          required: false,
          helpText: 'Enter the Limited Section Text.',
        },
        {
          name: 'limitedImage',
          type: 'file',
          required: true,
          allowedFileTypes: ['png', 'jpg', 'jpeg'],
          description: 'Image for the Limited section',
        },
        {
          name: 'limitedProduct',
          type: 'string',
          required: false,
          helpText: 'Enter the Limited Product.',
        },
        {
          name: 'extraProducts',
          type: 'string',
          defaultValue: '',
          helpText: 'Comma-separated list of product.creator IDs to render extra full-width rows',
        },
        {
          name: 'topProducts',
          type: 'string',
          required: true,
          helpText: 'Enter the Top Products.',
        },
        {
          name: 'bottomProducts',
          type: 'string',
          required: false,
          helpText: 'Enter the Bottom Products.',
        },
        {
          name: 'isTabsVisible',
          type: 'boolean',
          defaultValue: true,
          helpText: 'Toggle to show/hide this tab.',
        },
        {
          name: 'showProductsOneRow',
          type: 'boolean',
          defaultValue: false,
          helpText: 'Toggle to show the one Product per row.',
        },
        {
          name: 'showZakatButton',
          type: 'boolean',
          defaultValue: true,
          helpText: 'Toggle to display the Zakat Button.',
        },
      ],
    },
  ],
});

export default QurbanWidget;
